import { useState, useCallback, useEffect } from 'react'
import { Input, Row, Message, DateInput, Col, Icon } from '@iqueue/ui-kit'
import moment from 'moment'
import { t } from '../../hooks/useTranslate'

export default function UsersUpsertForm({ model }) {
  const [password, setPassword] = useState()
  const [dateOfBirth, setDateOfBirth] = useState(model.profile?.dateOfBirth ? moment(model.profile?.dateOfBirth) : undefined)

  const generateRandomPassword = useCallback((length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+[]{}|;:,.<>?'
    let result = ''
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length)
      result += characters[randomIndex]
    }
    return result
  }, [])

  const regeneratePassword = useCallback(() => {
    setPassword(generateRandomPassword(20))
  }, [])

  const copyToClipboard = useCallback((text) => {
    navigator.clipboard.writeText(text).then(() => {
      Message({
        type: 'info',
        timeout: 5000,
        title: t('user.form.passwordCopied'),
      })
    })
  }, [])

  useEffect(() => {
    regeneratePassword()
  }, [regeneratePassword])

  return <>
    <Input name={ 'id' } hidden value={ model.id }/>
    <Input name={ 'profile.id' } hidden value={ model?.profile?.id }/>

    <div className={ 'user-name-box' }>
      <span className={ 'user-icon' }>
        <Icon>
          person
        </Icon>
      </span>
      <span className={ 'user-name' }>{ model?.username }</span>
    </div>

    { !model.id && <Row>
      <Input
        required
        size={ 12 }
        name={ 'username' }
        placeholder={ t('user.form.username') }
        value={ model.username }
      />
    </Row> }

    { !model.id && <Row>
      <Input
        size={ 12 }
        required
        name={ 'password' }
        placeholder={ t('user.form.password') }
        value={ password }
        onChange={ (e) => setPassword(e.target.value) }
        actions={ [
          {
            key: 'refresh',
            icon: 'refresh',
            onClick: regeneratePassword,
          },
          {
            key: 'copy',
            icon: 'content_copy',
            onClick: () => copyToClipboard(password),
          },
        ] }
      />
    </Row> }

    <Row>
      <Input
        size={ 6 }
        name={ 'profile.name' }
        placeholder={ t('user.form.name') }
        value={ model.profile?.name }
        required
      />

      <Input
        size={ 6 }
        name={ 'profile.surname' }
        placeholder={ t('user.form.surname') }
        value={ model.profile?.surname }
        required
      />
    </Row>
    <Row>
      <Input
        size={ 6 }
        name={ 'profile.patronymic' }
        placeholder={ t('user.form.patronymic') }
        value={ model.profile?.patronymic }
      />

      <DateInput
        size={ 6 }
        name={ 'profile.dateOfBirth' }
        placeholder={ t('user.form.dateOfBirth') }
        value={ dateOfBirth }
        min={ moment('1950') }
        onChange={ (v) => {
          setDateOfBirth(v)
        } }/>

    </Row>
    <Row>
      <Input
        name={ 'profile.phoneNumber' }
        size={ 12 }
        value={ model?.profile?.phoneNumber }
        placeholder={ t('user.form.phoneNumber') }
      />
    </Row>
  </>
}
